import React from 'react'
import isEqual from 'react-fast-compare'
import { getTextColor } from '@disco/utils/colors'
import ArtistArtwork from 'components/common/artist-artwork'
import type { LinkComponentType } from 'components/ui/grid-item'
import GridItem from 'components/ui/grid-item'
import Lozenge from 'components/ui/lozenge'
type Props = {
  image?: string | null | undefined
  link?: LinkComponentType
  overlayActions?: React.ReactNode
  overlayVisible?: boolean
  status?: string | null | undefined
  title: string
  imageParams?: Record<string, any>
}

/**
 * Grid item component for displaying artist information with circular artwork
 * @param image - URL of the artist image
 * @param link - Link component configuration for navigation
 * @param overlayActions - Actions to display in the circular overlay on hover
 * @param overlayVisible - Whether to show the overlay
 * @param status - Status text to display as a lozenge
 * @param title - Artist name to display
 * @param imageParams - Parameters for image optimization
 */
const ArtistGridItem = ({
  image,
  link,
  overlayActions,
  overlayVisible,
  status,
  title,
  imageParams,
}: Props) => {
  const overlay: React.ReactNode = (
    <GridItem.Overlay
      appearance="circle"
      actions={overlayActions}
      visible={overlayVisible}
    />
  )
  const media: React.ReactNode = (
    <ArtistArtwork
      color={getTextColor(title)}
      image={image}
      imageParams={imageParams}
      overlay={overlay}
      status={status && <Lozenge color="yellow" text={status} />}
    />
  )
  return <GridItem link={link} media={media} title={title} />
}

export default React.memo<Props>(ArtistGridItem, isEqual)
